// extracted by mini-css-extract-plugin
export var menuItem = "z_tM d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_tN d_Z d_bz d_bP";
export var menuMainLink = "z_tP d_f0 d_dB";
export var menuLink = "z_tQ d_f0 d_dB";
export var icon = "z_p9 d_bC d_bP";
export var divider = "z_tR d_bC d_bP";
export var sublinks = "z_tS";
export var link = "z_mZ";
export var Link = "z_rt q_rt q_qH q_q1";